import { Coord } from "../../../../../../../../../src/types/Interface";
import getAngleBetweenPoints from "../../../../../../../../../src/utils/math/getAngleBtwPoints";

export default function getNonParallelLineCoords(shapeCoords: Coord[], rShapeCoord: Coord[]) {
  const slopeArr = [...shapeCoords].map((c, cI) => getAngleBetweenPoints(c, rShapeCoord[cI]));
  const secondIndex = [...slopeArr].map((s, sI) => sI !== 0 && s !== slopeArr[0] ? sI : -1).filter(a => a !== -1)[0]
  return [0, secondIndex];
}